import React from 'react';

type TableLoadingRowProps = {
  colSpan: number;
  label?: string;
};

const TableLoadingRow = ({ colSpan, label = 'Loading data...' }: TableLoadingRowProps) => (
  <tr>
    <td colSpan={colSpan}>
      <div className="table-loading-state" role="status" aria-live="polite" aria-label={label}>
        <span className="spinner-border spinner-border-sm" aria-hidden="true" />
        <span>{label}</span>
      </div>
    </td>
  </tr>
);

export default TableLoadingRow;
